/* Share button v1 is not being replaced as it's still used in documents. If we ever swap it for this one, file should be safe for deletion. */

import * as React from "react";
import { connect, ConnectedProps } from "react-redux";
import { GlobalApplicationState } from "globalApplicationState";
import IconButton from "@mui/material/IconButton";
import ShareIcon from "@mui/icons-material/Share";
import { useState } from "react";
import { List, Popover } from "@mui/material";
import MoreOptionsItem from "../moreOptionsItem";

import "../dialogs/shareDialog.sass";

const ShareButtonv2: React.FunctionComponent<PropsWithRedux> = (props) => {
    const [shareOptionsOpen, setShareOptionsOpen] = useState(false);
    const shareRef = React.useRef(null);
    const isShareEnabled = props.shareUrlsConfig.toggleCompanyPortalUrl ||
        props.shareUrlsConfig.toggleSpUrl ||
        props.shareUrlsConfig.toggleTeamsUrl;

    if (!isShareEnabled) return <></>;

    const onShow = () => {
        if(props.isPublic) {
            if(props.isAuthenticated) {
                setShareOptionsOpen(true);
            }
            else if (props.togglePublicShare){
                props.togglePublicShare(true);
            }
        }
        else {
            props.toggleInternalShare(true);
        }
    }

    const { linkText } = props;

    return (
      <div className={`share-button ${linkText ? "link" : "share"}`}>
        {linkText
          ? <div title="Share" onClick={onShow} className="link-text">
              {linkText}
            </div>
          : <IconButton title="Share" size={props.size === "small" ? "small" : "medium"} onClick={onShow} style={{backgroundColor: shareOptionsOpen ? "#F2F2EF" : ""}}>
              <ShareIcon fontSize={props.size === "small" ? "small" : "medium"} />
            </IconButton>
        }
        <div ref={shareRef} className="popover-container"/>
        <Popover
            open={shareOptionsOpen}
            onClose={() => setShareOptionsOpen(false)}
            anchorEl={shareRef.current}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
        >
            <List disablePadding>
                <MoreOptionsItem
                    text={`Share with people in ${props.tenantName}`}
                    hoverStyle={{backgroundColor: "#F2F2EF"}}
                    onClick={() => {
                        setShareOptionsOpen(false);
                        props.toggleInternalShare(true)
                    }} 
                />
                <MoreOptionsItem
                    text={`Share publicly`}
                    hoverStyle={{backgroundColor: "#F2F2EF"}}
                    onClick={() => {
                        setShareOptionsOpen(false);
                        
                        if(props.togglePublicShare)
                            props.togglePublicShare(true);
                    }} 
                />
            </List>
        </Popover>
      </div>
  );
}


interface IShareButtonv2Props {
  size?: "default" | "small";
  isPublic?: boolean;
  linkText?: string;
  isAuthenticated: boolean;
  togglePublicShare?: (toSet: boolean) => void;
  toggleInternalShare: (toSet: boolean) => void;
}

const connector = connect(
  (state: GlobalApplicationState, ownProps: IShareButtonv2Props) => ({
    ...ownProps,
    tenantId: state.tenant.id,
    tenantName: state.settings.clientSettings.displayName,
    shareUrlsConfig: state.settings.clientSettings.shareUrlsConfig,
  })
);
type PropsWithRedux = ConnectedProps<typeof connector>;
export default connector(ShareButtonv2);
